import * as Yup from "yup";

export const validation = Yup.object().shape({
  idServicio: Yup.string().required("Campo requerido.").nullable(),
  idPais: Yup.number().required("Campo requerido.").nullable(),
  valorSena: Yup.number().required("Campo requerido.").nullable(),
  email: Yup.string().required("Campo requerido.").nullable(),
});
